import { Controller } from "stimulus"

export default class extends Controller {
	static targets = [ 'form' ]

	onUserDetailsPostError(event) {
		let [data, status, xhr] = event.detail

		if (data.error) {
			$("#new_email_advocacy_submission .error").html(`<p>${data.error}</p>`)
		} else {
			$("#new_email_advocacy_submission").render_form_errors('email_advocacy_submission', data)
		}
	}
}